import { SVGProps } from 'react';

export function ProductionLine(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='24'
      fill='none'
    >
      <rect
        width='24'
        height='24'
        rx='2'
        fill='#F9F0FF'
      />
      <g clipPath='url(#clip0_1415_53447)'>
        <path
          d='M6 18H18'
          stroke='#722ED1'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.33325 18V10L10.6666 12.6667V10L13.9999 12.6667H16.6666'
          stroke='#722ED1'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.6666 18V12.6667L15.7093 6.284C15.6974 6.20497 15.6576 6.13281 15.597 6.08068C15.5365 6.02855 15.4592 5.99992 15.3793 6H14.6159C14.5369 5.99988 14.4604 6.02783 14.4001 6.07887C14.3398 6.12991 14.2995 6.20072 14.2866 6.27867L13.3333 12'
          stroke='#722ED1'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10 15.333H10.6667'
          stroke='#722ED1'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.3333 15.333H13.9999'
          stroke='#722ED1'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1415_53447'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(4 4)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
